import {
  BatchStatisticsLendSelectShelfConditionListItem,
  BatchStatisticsLendSelectShelfConditionListItemFromJSON
} from '@/api/models/batch/BatchStatisticsLendSelectShelfConditionListItem'

export interface BatchStatisticsLendSelectShelfPageLoadResult {
  items: BatchStatisticsLendSelectShelfConditionListItem
}

export function BatchStatisticsLendSelectShelfPageLoadResultFromJSON(
  json: any
): BatchStatisticsLendSelectShelfPageLoadResult {
  return {
    items: BatchStatisticsLendSelectShelfConditionListItemFromJSON(json)
  }
}
